import apiClient from '../apiClient';
import { GET_DATA_TRANSFER_LOGS_BY_REFERENCE_ID_URL } from '../apiUrl';

const getDataTransferLogsByReferenceIdApi = referenceId => {
  return apiClient.get(GET_DATA_TRANSFER_LOGS_BY_REFERENCE_ID_URL(referenceId));
};

export default getDataTransferLogsByReferenceIdApi;
